import { render, staticRenderFns } from "./Personality.vue?vue&type=template&id=0df2e252&scoped=true&"
import script from "./Personality.vue?vue&type=script&lang=js&"
export * from "./Personality.vue?vue&type=script&lang=js&"
import style0 from "./Personality.vue?vue&type=style&index=0&id=0df2e252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df2e252",
  null
  
)

export default component.exports